export class LanguageOptions {
  "en" = "";
  /*"fr": string | null;
  "es": string | null;
  "de": string | null;
  "pt": string | null;
  */
}

enum Language {
  EN = "en",
  FR = "fr",
  ES = "es",
  DE = "de",
  PT = "pt",
}

export { Language };
